import React, {useState} from "react";
import {
    Box,
    Checkbox,
    FormControl,
    FormControlLabel,
    Grid,
    Input,
    InputLabel, MenuItem,
    Modal, Select,
    TextField,
    Typography
} from "@mui/material";
import "./createScoreCard.scss";
import PropTypes from "prop-types";

const CreateScoreCard = ({onSelectCriteria}) => {
    const [scoreCardName, setScoreCardName] = useState('');
    const [selectedScoreCards, setSelectedScoreCards] = useState([]);
    const [showCreateCriteriaModal, setShowCreateCriteriaModal] = useState(false);
    const [criteriaPriority, setCriteriaPriority] = useState("");

    const checkboxOptions = [
        { id: '1', name: 'Communication & Engagement' },
        { id: '2', name: 'Question Handling' },
        { id: '3', name: 'Forward Motion' },
        { id: '4', name: 'Empathy' },
        { id: '5', name: 'Confidence' },
        { id: '6', name: 'Energy' }
    ];
    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        const index = selectedScoreCards.indexOf(name);

        if(checked && index === -1) {
            setSelectedScoreCards(scoreCards => [...scoreCards, name])
        } else if(!checked && index !== -1) {
            setSelectedScoreCards(scoreCards => scoreCards.splice(index, 1))
        }
    };
    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
    };

    const handleNameChange = (e) => {
        setScoreCardName(e.target.value);
    }
    const openCreateCriteriaModal = () => {
        setShowCreateCriteriaModal(true);
    }
    const closeCreateCriteriaModal = () => {
        setShowCreateCriteriaModal(false);
    }

    return <div className={"choose-criteria-container"}>
        <p className={"steps-title"}>Generate Score Card</p>
        <Input value={scoreCardName} sx={{alignSelf: "flex-start"}}
            required onChange={handleNameChange} type={"text"} placeholder={"Name of score card"}/>
        <div className={"select-criteria"}>
            <p className={"steps-sub-title"}>Select Criteria</p>
            <button className={'colored-button'}
                     style={{width: '170px'}}
                    onClick={openCreateCriteriaModal}
        >
            Create Custom Criteria
        </button>
        </div>

        <Grid container spacing={2} className={"score-cards-container"} sx={{width: "100%"}}>
        {
            checkboxOptions.map(({id, name}) => (
                <Grid item md={6} xs={12}>
                    <div className={`score-card ${selectedScoreCards.indexOf(id) !== -1 ? 'gradient-border' : ''}`}>
                        <FormControlLabel
                            key={id}
                            value="start"
                            control={<Checkbox style ={{color: "#DB3B5C"}} onClick={handleCheckboxChange}/>}
                            label={name}
                            name={id}
                            labelPlacement="start"
                        />
                    </div>
                </Grid>
            ))
        }
        </Grid>

        <div>


            {/*<button className={`colored-button medium-font-size ${selectedScoreCards.length === 0 ? "disabled-button" : ""}`}*/}
            {/*        style={{width: '250px'}}*/}
            {/*>*/}
            {/*    Select From Existing Score Cards*/}
            {/*</button>*/}
            {/*<button className={`colored-button medium-font-size ${selectedScoreCards.length === 0 ? "disabled-button" : ""}`}*/}
            {/*        style={{width: '250px'}} onClick={onSelectCriteria}*/}
            {/*>*/}
            {/*    Create Score Card*/}
            {/*</button>*/}
        <button disabled={selectedScoreCards.length === 0 || !scoreCardName }
                title={selectedScoreCards.length === 0 || !scoreCardName ? "Please name score card and select at least one call score criteria" : ""}
                className={`colored-button medium-font-size ${selectedScoreCards.length === 0  || !scoreCardName ? "disabled-button" : ""}`}
                style={{width: '250px'}}
                onClick={onSelectCriteria}>
            Create Score Card
        </button>
        </div>
        <Modal
            open={showCreateCriteriaModal}
            onClose={closeCreateCriteriaModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style}>
                <Typography id="modal-modal-title" variant="h6" component="h2">
                    Create Criteria
                </Typography>
                <div style={{padding: "12px 0"}}>
                <div style={{display: "flex", gap: "12px"}}>
                    <Input placeholder={"criteria name"}/>
                    <Input placeholder={"criteria description"}/>
                </div>
                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                    Checklist Questions
                </Typography>
                    <div style={{display: "flex", gap: "12px"}}>
                        <Input placeholder={"question"} style={{flex: 2}}/>
                        <FormControl fullWidth style={{flex: 1}}>
                            <InputLabel id="demo-simple-select-label">Priority</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={criteriaPriority}
                                label="Age"
                                onChange={(e) => setCriteriaPriority(e.target.value)}
                            >
                                <MenuItem value={"high"}>High</MenuItem>
                                <MenuItem value={"medium"}>Medium</MenuItem>
                                <MenuItem value={"low"}>Low</MenuItem>
                            </Select>
                        </FormControl>
                    </div>
                </div>
            </Box>
        </Modal>

    </div>
}

export default CreateScoreCard;

CreateScoreCard.prototype = {
    onSelectCriteria: PropTypes.func
}